<div class="dialog-header">
  <h2 mat-dialog-title>Onboard New Meter</h2>
  <button mat-icon-button 
          class="close-button" 
          (click)="onCancel()" 
          [disabled]="registrationInProgress"
          aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="onboard-dialog">
  
  <form [formGroup]="onboardForm" (ngSubmit)="onSubmit()">
    <mat-horizontal-stepper #stepper [linear]="true" class="onboard-stepper">
      
      <!-- Step 1: Customer Details (only for TPI users) -->
      <mat-step *ngIf="data.isTpi" [stepControl]="onboardForm.get('customerDetails')!">
        <ng-template matStepLabel>Customer Details</ng-template>
        
        <div class="step-content">
          <app-customer-details formControlName="customerDetails"></app-customer-details>
        </div>
      </mat-step>

      <!-- Step 2: Meter Selection -->
      <mat-step [stepControl]="onboardForm.get('meterSelection')!">
        <ng-template matStepLabel>Meter Details</ng-template>
        
        <div class="step-content">
          <app-meter-selection 
            formControlName="meterSelection"
            [multiple]="true">
          </app-meter-selection>
        </div>
      </mat-step>

      <!-- Step 3: Consent -->
      <mat-step [stepControl]="onboardForm.get('consent')!">
        <ng-template matStepLabel>Consent</ng-template>
        
        <div class="step-content">
          <!-- File Upload Case: Show message instead of consent component -->
          <div *ngIf="isFileUploadSelected()" class="file-upload-consent">
            <mat-card class="info-card">
              <mat-card-header>
                <mat-card-title>
                  <mat-icon>email</mat-icon>
                  Email Verification Process
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <p>For bulk meter onboarding via file upload:</p>
                <ul>
                  <li>We will verify each meter in your uploaded file</li>
                  <li>Individual consent requests will be sent via email for each valid meter</li>
                  <li>You will receive confirmation emails for each processed meter</li>
                  <li>Invalid meters will be reported back to you with reasons</li>
                </ul>
                <div class="file-info">
                  <mat-icon>description</mat-icon>
                  <span><strong>File:</strong> {{ getSelectedFileName() }}</span>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <!-- Individual Meter Case: Show consent component -->
          <div *ngIf="!isFileUploadSelected()">
            <app-consent-wallet-fc
              formControlName="consent"
              [customerDetails]="getCustomerDetailsForConsent()"
              [meterDetails]="getMeterDetailsForConsent()"
              [isRequestor]="data.isTpi"
              (consentChange)="onboardForm.get('consent')?.setValue($event)">
            </app-consent-wallet-fc>
          </div>
        </div>
      </mat-step>

    </mat-horizontal-stepper>
  </form>
</div>

<div mat-dialog-actions class="dialog-actions">
  <!-- Step Navigation and Submit Actions -->
  <div class="step-navigation">
    <button mat-button  
            (click)="stepper.previous()"
            *ngIf="stepper && stepper.selectedIndex > 0" 
            [disabled]="registrationInProgress">
      Back
    </button>
    
    <div class="right-actions">
      <button mat-button
              (click)="stepper.next()"
              *ngIf="stepper && stepper.selectedIndex < getMaxStepIndex() && !isLastStep()" 
              [disabled]="!isCurrentStepValid()">
        Next
      </button>
      
      <button mat-flat-button color="primary" 
              *ngIf="isLastStep()"
              [disabled]="!canFinish() || registrationInProgress" 
              (click)="onSubmit()"
              >
        <!-- <mat-spinner *ngIf="registrationInProgress" diameter="20"></mat-spinner> -->
        <span *ngIf="!registrationInProgress">Onboard Meter</span>
        <span *ngIf="registrationInProgress">Processing...</span>
      </button>
    </div>
  </div>
</div>
